import React, { useEffect, useState } from 'react';

import cn from 'classnames';

import { useDebounce } from 'hooks/useDebounce/useDebounce';
import { SelectPropertiesType } from 'hooks/useSelectProperties/useSelectProperties';
import { Select } from 'ui-kit';

import './PropertiesSelect.scss';

type PropertiesSelectType = {
  selectProperties: SelectPropertiesType;
  className?: string;
};

export const PropertiesSelect = ({
  className,
  selectProperties,
}: PropertiesSelectType) => {
  const {
    selectOptions,
    selectedValue,
    onChangeSelect,
    onInputChangeSelect,
    onFocusSelect,
    onMenuScrollToBottom,
  } = selectProperties;

  const [inputValue, setInputValue] = useState<string>('');
  const debouncedInputValue = useDebounce(inputValue, 500);

  useEffect(() => {
    onInputChangeSelect(debouncedInputValue);
  }, [debouncedInputValue, onInputChangeSelect]);

  return (
    <Select
      onFocus={onFocusSelect}
      isSearchSelect
      placeholder="Find property"
      options={selectOptions}
      isMulti
      value={selectedValue}
      onChange={value => onChangeSelect(value)}
      onInputChange={(value, actionMeta) => {
        if (actionMeta?.action === 'input-blur' || actionMeta?.action === 'menu-close') {
          return;
        }
        setInputValue(value);
      }}
      className={cn('PropertiesSelect', className)}
      onMenuScrollToBottom={onMenuScrollToBottom}
    />
  );
};
